@use '@/scss/underscore' as _;

.textDivider {
  font: var(--font-body-2);
  color: var(--color-text-secondary);
  margin: _.unit(6) 0 _.unit(4);
}
